import { ProductConfig } from '@/data/productsConfig';
import { DYNAMIC_CONFIG_NAMES, getConfig } from '@/lib/statsig';
import { Countries } from '@/types/Countries';

/**
 * This utility gets the `productId` from the Statsig config
 * for countries and cities where heavy use subscriptions are
 * disabled. The `productId` is then used as a product the `HeavyUseDisabledLabel`
 * component links to.
 *
 * @param country - the country code
 * @param city - the city name
 * @param productConfig - the product config of the selected product
 * @returns the productId to link to
 */
export const getHeavyUseRestrictionProductId = (
  country: Countries,
  city: string,
  productConfig: ProductConfig
) => {
  const config = getConfig(DYNAMIC_CONFIG_NAMES.heavyUseRestriction, {
    custom: {
      country,
      city: city,
      productId: productConfig.id,
    },
  });

  return config?.get<ProductConfig['id'] | undefined>('productId', undefined);
};
